const authentication = require('../../../react-azure-adb2c2').default;


export const list = (values: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/groups/list`;
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/groups/list`;

    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const insert = (value: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/groups/insert`;
    let url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/groups/insert`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const delete_group = (value: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/groups/delete/`+value;
    let url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/groups/delete/`+value;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'put',
        // body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const update = (value: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/groups/update`;
    let url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/groups/update`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const update_sort = (value: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/groups/updatesort`;
    let url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/groups/updatesort`;

    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(value),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};